export default __webpack_public_path__ + "static/media/ic_wftm_16.7bc8cea2.svg";